import { render } from "./_form-content-delegated-channel-inviting.vue?vue&type=template&id=39015ae5&lang=pug"
import script from "./_form-content-delegated-channel-inviting.vue?vue&type=script&lang=js"
export * from "./_form-content-delegated-channel-inviting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__